module.exports = __webpack_public_path__ + "static/media/CD-Sernee.affb5f65.jpg";